import PropTypes from "prop-types";
import { useEffect, useState } from "react";

// MUI
import { Grid, Skeleton, Stack } from "@mui/material";

export default function LineInputsLoader(props) {
	const [inputsAmount, setInputsAmount] = useState(2);

	useEffect(() => {
		if (props.inputsAmount) {
			setInputsAmount(props.inputsAmount);
		}
		return () => {
			setInputsAmount(2);
		};
	}, [props]);

	return (
		<Grid
			container
			item
			direction={"row"}
			mt={Number(props.mt) || 0.5}
			justifyContent={props.justifyContent || "center"}
			columnSpacing={2}
		>
			{Array.from(Array(inputsAmount)).map((_, key) => {
				const lineKey = `line_inputs_${key}`;
				return (
					<Grid item key={lineKey}>
						<Stack direction={"column"} alignItems={"center"} justifyContent={"center"}>
							{Boolean(props.title) && <Skeleton variant="text" width={80} height={20} />}
							<Skeleton variant="rectangular" width={100} height={30} sx={{ borderRadius: "6px" }} />
						</Stack>
					</Grid>
				);
			})}
		</Grid>
	);
}
LineInputsLoader.propTypes = {
	inputsAmount: PropTypes.number,
	mt: PropTypes.number,
	justifyContent: PropTypes.string,
	title: PropTypes.bool,
};
